import React from 'react'

import Button from 'components/Btn'

export function DevMenu() {
  return (
    <div style={{ display: 'flex', gap: '0.5rem', padding: '0.5rem', borderBottom: '1px solid rgba(255,255,255,0.2' }}>
      <Button
        sm
        to="/dev/icons"
      >
        Icons
      </Button>
      <Button
        sm
        to="/dev/buttons"
      >
        Buttons
      </Button>
      <Button
        sm
        to="/dev/dialogs"
      >
        Dialogs
      </Button>
      <Button
        sm
        to="/dev/forms"
      >
        Forms
      </Button>
    </div>
  )
}
